import * as React from 'react';
import { Typography, Alert } from 'antd';
const { Title, Text, Paragraph } = Typography;
import { IWidget } from 'common/schema/widget/Widget';
import './FormWidgetGraphicInfoView.scss';
import { WidgetGraphicMultilineText } from '../helper/WidgetGraphicMultilineText';

export interface FormWidgetGraphicInfoViewProps {
  widget: IWidget;
}

export function FormWidgetGraphicInfoView(
  props: FormWidgetGraphicInfoViewProps
) {
  return (
    <Alert
      className="graphic-section-info"
      message={props.widget.graphic!.title}
      description={
        <Paragraph>
          <WidgetGraphicMultilineText text={props.widget.graphic!.content} />
        </Paragraph>
      }
      type="info"
      showIcon
    />
  );
}
